import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ALLOWED_URL_SCHEMES} from '../common/Definitions/shared.definitions';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {

  constructor(private readonly sanitizer: DomSanitizer) {}

  public transform(url: string): SafeResourceUrl {
    if (!url || !ALLOWED_URL_SCHEMES.test(url)) {
      // Allow relative URLs (no scheme) or matched schemes only
      if (url && url.includes(':') && !ALLOWED_URL_SCHEMES.test(url)) {
        console.warn('SafePipe: blocked potentially unsafe URL scheme:', url);
        return '';
      }
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url); // NOSONAR - URL scheme is validated above against ALLOWED_URL_SCHEMES allowlist
  }
}
